export default __webpack_public_path__ + "static/NativePlantOrdinances-d8e20c0d5ac4a47faf9813aa20603d1f.jpg";